import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_invoice_termsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { invoiceTermId: number }): 
  Promise<{ result: { Id?: number, Description?: string, Name?: string, PeriodInDays?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceTermId)) {
      missingRequiredInParams.push('\'invoiceTermId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_invoice_terms/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      invoiceTermId: number    }) {
        if(isNil(inParams.invoiceTermId)) {
          return true; 
        }
      return false;
    }
}
